<template>
  <div class="content-block">
    <div class="dx-card responsive-paddings">
      <!-- <div class="card-deck">
          <div class="card">
            <img class="card-img-top" src="#" alt="Card image cap" />
            <div class="card-body">
              <h5 class="card-title">Card title</h5>
              <p class="card-text">
                This is a longer card with supporting text below as a natural
                lead-in to additional content. This content is a little bit
                longer.
              </p>
              <p class="card-text">
                <small class="text-muted">Last updated 3 mins ago</small>
              </p>
            </div>
          </div>
          <div class="card">
            <img class="card-img-top" src="#" alt="Card image cap" />
            <div class="card-body">
              <h5 class="card-title">Card title</h5>
              <p class="card-text">
                This card has supporting text below as a natural lead-in to
                additional content.
              </p>
              <p class="card-text">
                <small class="text-muted">Last updated 3 mins ago</small>
              </p>
            </div>
          </div>
          <div class="card">
            <img class="card-img-top" src="#" alt="Card image cap" />
            <div class="card-body">
              <h5 class="card-title">Card title</h5>
              <p class="card-text">
                This is a wider card with supporting text below as a natural
                lead-in to additional content. This card has even longer content
                than the first to show that equal height action.
              </p>
              <p class="card-text">
                <small class="text-muted">Last updated 3 mins ago</small>
              </p>
            </div>
          </div>
        </div> -->
      <p class="text-muted font-weight-light">Notifikasi Penjagaan</p>
      <div class="row row-cols-1 row-cols-md-4 g-4">
        <div class="col">
          <div
            class="card text-black mb-3"
            style="background-color: rgba(243, 158, 108, 0.8) !important"
          >
            <a href="#" class="dashboard-card" style="color: black">
              <div class="card-body">
                <h4
                  class="card-title"
                  style="font-weight: bold; color: aliceblue"
                >
                  100
                </h4>
                <p class="card-text" style="font-weight: bold; font-size: 16px">
                  Kenaikan Gaji Berkala April 2023
                </p>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div
            class="card text-black mb-3"
            style="background-color: rgba(148, 215, 199, 0.8) !important"
          >
            <a href="#" class="dashboard-card" style="color: black">
              <div class="card-body">
                <h4
                  class="card-title"
                  style="font-weight: bold; color: aliceblue"
                >
                  100
                </h4>
                <p class="card-text" style="font-weight: bold; font-size: 16px">
                  Kenaikan Pangkat April 2023
                </p>
              </div>
            </a>
          </div>
        </div>

        <div class="col">
          <div
            class="card text-black mb-3"
            style="background-color: rgba(119, 199, 231, 0.8) !important"
          >
            <a href="#" class="dashboard-card" style="color: black">
              <div class="card-body">
                <h4
                  class="card-title"
                  style="font-weight: bold; color: aliceblue"
                >
                  100
                </h4>
                <p class="card-text" style="font-weight: bold; font-size: 16px">
                  Pegawai Pensiun Tahun 2023
                </p>
              </div>
            </a>
          </div>
        </div>

        <div class="col">
          <div
            class="card text-black mb-3"
            style="background-color: rgba(123, 155, 207, 0.8) !important"
          >
            <a href="#" class="dashboard-card" style="color: black">
              <div class="card-body">
                <h4
                  class="card-title"
                  style="font-weight: bold; color: aliceblue"
                >
                  100
                </h4>
                <p class="card-text" style="font-weight: bold; font-size: 16px">
                  Kenaikan Pangkat April 2023
                </p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="content-block">
    <div class="dx-card responsive-paddings">
      <p class="text-muted font-weight-light">
        Rangkuman Statistik Kepegawaian Perusahaan
      </p>
      <div class="row row-cols-1 row-cols-md-5 g-4">
        <div class="col">
          <div class="card h-100">
            <a href="#" class="dashboard-card" style="color: black">
              <div class="card-body">
                <h5 class="card-title">200</h5>
                <p class="card-text">Pegawai Aktif</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <a href="#" class="dashboard-card" style="color: black">
              <div class="card-body">
                <h5 class="card-title">500</h5>
                <p class="card-text">Pegawai Tetap</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <a href="#" class="dashboard-card" style="color: black">
              <div class="card-body">
                <h5 class="card-title">500</h5>
                <p class="card-text">Pegawai Capeg</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <a href="#" class="dashboard-card" style="color: black">
              <div class="card-body">
                <h5 class="card-title">500</h5>
                <p class="card-text">Pekerja Kontrak</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <a href="#" class="dashboard-card" style="color: black">
              <div class="card-body">
                <h5 class="card-title">500</h5>
                <p class="card-text">Pegawai Magang</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <a href="#" class="dashboard-card" style="color: black">
              <div class="card-body">
                <h5 class="card-title">500</h5>
                <p class="card-text">Pegawai Pensiun</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <a href="#" class="dashboard-card" style="color: black">
              <div class="card-body">
                <h5 class="card-title">100</h5>
                <p class="card-text">Pegawai Laki-Laki</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <a href="#" class="dashboard-card" style="color: black">
              <div class="card-body">
                <h5 class="card-title">100</h5>
                <p class="card-text">Pegawai Perempuan</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <a href="#" class="dashboard-card" style="color: black">
              <div class="card-body">
                <h5 class="card-title">100</h5>
                <p class="card-text">Pegawai Pendidikan SMA</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <a href="#" class="dashboard-card" style="color: black">
              <div class="card-body">
                <h5 class="card-title">100</h5>
                <p class="card-text">Pegawai Pendidikan D1</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <a href="#" class="dashboard-card" style="color: black">
              <div class="card-body">
                <h5 class="card-title">100</h5>
                <p class="card-text">Pegawai Pendidikan D2</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <a href="#" class="dashboard-card" style="color: black">
              <div class="card-body">
                <h5 class="card-title">100</h5>
                <p class="card-text">Pegawai Pendidikan D3</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <a href="#" class="dashboard-card" style="color: black">
              <div class="card-body">
                <h5 class="card-title">100</h5>
                <p class="card-text">Pegawai Pendidikan D4</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <a href="#" class="dashboard-card" style="color: black">
              <div class="card-body">
                <h5 class="card-title">100</h5>
                <p class="card-text">Pegawai Pendidikan S1</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="content-block">
    <div class="row row-cols-1 row-cols-md-2">
      <div class="col">
        <div class="dx-card responsive-paddings">
          <DxChart
            id="chart"
            :data-source="populationData"
            title="Statistik Golongan Ruang"
          >
            <DxArgumentAxis :tick-interval="10">
              <DxLabel format="decimal" />
            </DxArgumentAxis>
            <DxSeries type="bar" />
            <DxLegend :visible="false" />
          </DxChart>
          <a href="#" class="btn">Lihat Detail</a>
        </div>
      </div>
      <div class="col">
        <div class="dx-card responsive-paddings">
          <DxChart
            id="chart"
            :data-source="populationData"
            title="Statistik Pendidikan"
          >
            <DxArgumentAxis :tick-interval="10">
              <DxLabel format="decimal" />
            </DxArgumentAxis>
            <DxSeries type="bar" />
            <DxLegend :visible="false" />
          </DxChart>
          <a href="#" class="btn">Lihat Detail</a>
        </div>
      </div>
      <div class="col">
        <div class="dx-card responsive-paddings">
          <DxChart
            id="chart"
            :data-source="populationData"
            title="Statistik Usia"
          >
            <DxArgumentAxis :tick-interval="10">
              <DxLabel format="decimal" />
            </DxArgumentAxis>
            <DxSeries type="bar" />
            <DxLegend :visible="false" />
          </DxChart>
          <a href="#" class="btn">Lihat Detail</a>
        </div>
      </div>
      <div class="col">
        <div class="dx-card responsive-paddings">
          <DxChart
            id="chart"
            :data-source="populationData"
            title="Statistik Jabatan"
          >
            <DxArgumentAxis :tick-interval="10">
              <DxLabel format="decimal" />
            </DxArgumentAxis>
            <DxSeries type="bar" />
            <DxLegend :visible="false" />
          </DxChart>
          <a href="#" class="btn">Lihat Detail</a>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>

<script>
import DxChart, {
  DxArgumentAxis,
  DxLegend,
  DxLabel,
  DxSeries,
} from "devextreme-vue/chart";

import { populationData } from "./populationData.js";

const palette = ["#c3a2cc", "#b7b5e0", "#e48cba"];

export default {
  components: {
    DxChart,
    DxArgumentAxis,
    DxLabel,
    DxLegend,
    DxSeries,
  },
  data() {
    return {
      populationData,
      temperature: [2, 4, 6, 8, 9, 10, 11],
      screen(width) {
        return width < 700 ? "sm" : "lg";
      },
    };
  },
  methods: {
    changeTemperature({ value }) {
      this.monthWeather.filter(["t", ">", value]);
      this.monthWeather.load();
    },
    customizeLabelText({ valueText }) {
      return `${valueText}${"&#176C"}`;
    },
    customizePoint() {
      const color = palette[this.paletteIndex];
      this.paletteIndex = this.paletteIndex === 2 ? 0 : this.paletteIndex + 1;

      return { color };
    },
  },
};
</script>
